// please be familiar with react-bootstrap-table-next column formaters
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Work%20on%20Columns&selectedStory=Column%20Formatter&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
import React from "react";

export function StatusColumnFormatterPemungut(cellContent, row) {
  const CustomerStatusCssClasses = ["primary", "success", "warning","danger", ""];
  const CustomerStatusTitles = ["Disetujui", "Pendaftaran", "Sudah Upload DJP Online", "Nonaktif", ""];
  let status = "";

  switch (row.status) {
    case 0:
      status = 1;
      break;

    case 1:
      status = 0;
      break;

    case 2:
      status = 2;
      break;
    case 3:
        status = 3;
        break;

    default:
      status = 4;
  }
  const getLabelCssClasses = () => {
    if(row.status === "Terima"){
      return '';
    } else {
      return `label label-lg label-light-${CustomerStatusCssClasses[status]} label-inline`;
    }
    
  };
  return (
    <span className={getLabelCssClasses()}>{CustomerStatusTitles[status]}</span>
  );
}


export function StatusColumnFormatterPenyediaAplikasi(cellContent, row) {
  const CustomerStatusCssClasses = ["primary", "success", "warning","danger", ""];
  const CustomerStatusTitles = ["Setujui", "Belum Disetujui", "Tolak", "Nonaktif", ""];
  let status = "";

  switch (row.status) {
    case "0":
      status = 1;
      break;

    case "1":
      status = 0;
      break;

    case "2":
      status = 2;
      break;
    case "3":
        status = 3;
        break;

    default:
      status = 4;
  }
  const getLabelCssClasses = () => {
    if(row.status === "Terima"){
      return '';
    } else {
      return `label label-lg label-light-${CustomerStatusCssClasses[status]} label-inline`;
    }
    
  };
  return (
    <span className={getLabelCssClasses()}>{CustomerStatusTitles[status]}</span>
  );
}


export function StatusColumnFormatterDashboardJenisReferensi(cellContent, row) {
  const CustomerStatusCssClasses = ["primary", "success", "warning","danger", ""];
  const CustomerStatusTitles = ["Setujui", "Belum Disetujui", "Tolak", "Nonaktif", ""];
  let status = "";

  switch (row.status) {
    case "0":
      status = 1;
      break;

    case "1":
      status = 0;
      break;

    case "2":
      status = 2;
      break;
    case "3":
        status = 3;
        break;

    default:
      status = 4;
  }
  const getLabelCssClasses = () => {
    if(row.status === "Terima"){
      return '';
    } else {
      return `label label-lg label-light-${CustomerStatusCssClasses[status]} label-inline`;
    }
    
  };

  const checkJenisReferensi = (val) => {
    if(row.refJenisSurat === 243){
return (
  <span>Kontraktor Utama PHLN</span>

)
    } else if(row.refJenisSurat === 244){
      return (
        <span>Registrasi BKP/JKP PHLN</span>
      
      )
    }
  }
  return (
    
    checkJenisReferensi(row.refJenisSurat)
    // <span className={getLabelCssClasses()}>{CustomerStatusTitles[status]}</span>
  );
}